import { useLanguage } from '@/src/contexts';
import { getText, normalizeCurrencyCode, TranslationKey } from '@/src/helpers';
import { Token } from '@/src/models';
import {
  Flex,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Text,
} from '@/src/ui-components';
import { TokenIcon } from '@/src/ui-components/token-icon';
import { useFormContext } from 'react-hook-form';
import { TokenSelectorsFormValues } from './token-selectors.types';

type ToProps = {
  tokens: Token[];
};

export const To = ({ tokens }: ToProps) => {
  const { control } = useFormContext<TokenSelectorsFormValues>();
  const { language } = useLanguage();
  const getTranslation = (key: TranslationKey) => getText(language, key);

  return (
    <Flex align="center" gap="2">
      <FormField
        control={control}
        name="to.amount"
        render={({ field }) => (
          <FormItem className="w-1/2">
            <FormLabel>{getTranslation('amount')}</FormLabel>
            <FormControl>
              {/* 👇 disable input for to amount as we enforce it to be -1 due to a bug in the ripple_path_find API when we define send_max and a destination_amount.value > 0
              https://github.com/XRPLF/rippled/issues/4369 */}
              <Input {...field} disabled={true} placeholder="0.0" />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="to.token"
        render={({ field }) => (
          <FormItem className="w-1/2">
            <FormLabel>Tokens</FormLabel>
            <FormControl>
              <Select onValueChange={field.onChange} defaultValue={field.value} value={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select a token" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {tokens.map((token) => {
                    return (
                      <SelectItem key={token.id} value={token.id} className="cursor-pointer">
                        <Flex align="center" gap="2">
                          <TokenIcon
                            src={token.icon || '/placeholder-token.svg'}
                            alt={token.code}
                            width={20}
                            height={20}
                          />
                          <Text weight="medium">{normalizeCurrencyCode(token.code)}</Text>
                          <Text weight="normal" className="text-xs text-muted-foreground">
                            {token.description}
                          </Text>
                        </Flex>
                      </SelectItem>
                    );
                  })}
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </Flex>
  );
};
